module.exports = __webpack_public_path__ + "static/media/social-reddit.e3afaecf.svg";